export { default as getRandomInt } from './getRandomInt'
